import { InfoTooltip } from "../../../shared/InfoTooltip";
import { getThemeAwareCssValue } from "../../charts/utils";

export const LegendLineIcon: React.FC<{ label: string; stroke?: string; tooltip?: string }> = ({
    label,
    stroke,
    tooltip,
}) => {
    const defaultStroke = getThemeAwareCssValue(
        "--ds-color-fjellgronn-visualisation-16",
        "--ds-color-fjellgronn-text-default",
    );

    return (
        <div key={label} className="custom-legend-item">
            <svg width="40" height="4" viewBox="0 0 40 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                <title>{label}</title>
                <line
                    x1="1.5"
                    y1="1.5"
                    x2="38.5"
                    y2="1.5"
                    stroke={stroke ?? defaultStroke}
                    strokeWidth="2"
                    strokeLinecap="round"
                />
            </svg>
            {label}

            {tooltip && <InfoTooltip text={tooltip} />}
        </div>
    );
};
